import FilterBar from '../../components/FilterBar';
import { CircularProgress, TextField } from '@mui/material';
import { CompanyFilter } from './companyTypes';
import { useFindAllCompaniesQuery } from '../../api/api-hooks';

interface Props {
  filters: CompanyFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: CompanyFilter;
}

const CompaniesFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const { data: companies } = useFindAllCompaniesQuery({});
  if (companies === undefined) return <CircularProgress></CircularProgress>;

  return (
    <FilterBar
      filters={filters}
      setFilters={setFilters}
      initialFilters={initialFilters}
      filterConstraintChecker={(name, value) => true}
      children={(handler: (event: any) => void) => [
        <TextField
          name='companyName'
          label='Company Name'
          variant='outlined'
          value={filters.companyName}
          onChange={handler}
        />,
      ]}
    />
  );
};

export default CompaniesFilterBar;
